import React from "react"
import Layout from "../components/Global/Layout/Layout"
import CaseStudiesHero from "../components/CaseStudies/CaseStudiesHero/CaseStudiesHero"
import CaseStudyGrid from "../components/CaseStudies/CaseStudyGrid/CaseStudyGrid"
import {
  BlurredCircleContainer,
  BlurredCircleLeft,
  BlurredCircleRight,
} from "../components/Global/Common/BlurredCircle/BlurredCircle"
import { FlexipageColors } from "../components/Flexipage/Global/FlexipageStyles"
import styled from "styled-components"
import CaseStudyCta from "../components/CaseStudies/CaseStudyCta/CaseStudyCta"
import SEO from "../components/Global/SEO/seo"
import { graphql, useStaticQuery } from "gatsby"

/**
 * @returns {{metaTitle: string, metaDescription: string}}
 */
function useCaseStudyMeta(){
  const query = useStaticQuery(graphql`
    query CaseStudyMetaQuery {
      statamic {
        globalSet(handle: "case_studies_page") {
          ... on Statamic_GlobalSet_CaseStudiesPage {
            meta_title
            meta_description
          }
        }
      }
    }
  `)

  const node = query?.statamic?.globalSet
  return {
    metaTitle: (node && node.meta_title) || "",
    metaDescription: (node && node.meta_description) || "",
  }
}

const CaseStudiesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6rem;
`;

export default function CaseStudies(){
  const meta = useCaseStudyMeta()
  return (
      <Layout showHelpSection={false}>
        <SEO title={meta.metaTitle} description={meta.metaDescription} />
        <BlurredCircleContainer>
          <BlurredCircleLeft size={275} top={0} offset={-25} color={FlexipageColors.teal600} />
          <BlurredCircleLeft size={275} top={1700} offset={-25} color={FlexipageColors.teal600} />

          <BlurredCircleRight size={275} top={700} offset={-25} color={FlexipageColors.teal600} />
        </BlurredCircleContainer>
        <CaseStudiesContainer>
          <CaseStudiesHero />
          <CaseStudyGrid />
          <CaseStudyCta />
        </CaseStudiesContainer>
      </Layout>
  )
}